import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';
import { CallupHead } from 'ThreeTerminal_mobile_dynamic';
import UserInfo from '../../../components/userInfo';
import FiXbottom from '../../../components/fixBottom';
import { getWeMediaPersonalData } from '../../../../services/api';
import styles from './index.css';
import SwitchTab from '../../../components/switchTab';
import ToBottomNoData from '../../../components/toBottomNoData';
import Main from './main';
import NoOriginal from '../../../components/noOriginal';
import TwiceShare from '../../../components/twiceShare';
import { h5PageCount } from 'ThreeTerminal_utils';
const CONFIG = {
    gv: '5.6.8',
    // nav: [{ tag: 1, name: '评论' }, { tag: 103, name: '分享' }, { tag: 106, name: '原创' }],
    nav: [{ tag: 1, name: '评论' }],
};
const isNullObject = obj => {
    if (typeof obj !== 'object') return console.error('请传入对象');

    return Object.keys(obj).length > 0;
};
const personalPageType = 'personalPage';
let currentDom = null;
const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

class Content extends React.PureComponent {
    static propTypes = { content: PropTypes.string };

    content = React.createRef();

    state = {
        share_token: this.props.content,
        data: {
            userinfo: {},
            list: [],
        },
        nav: CONFIG.nav,
        type: 1,
        pagesize: 10,
        page: 1,
        totalPage: 1,
        flag: true,
        isLoadEnd: false,
    };

    getContentData = async (newType, newPage) => {
        const { share_token, type, page } = this.state;
        const gv = CONFIG.gv;
        const currentType = newType ? newType : type;
        const currentPage = newPage ? newPage : page;
        const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
        const proid = isVideoShare ? 'ifengvideoh5' : 'ifengnewsh5';

        const params = {
            share_token,
            type: currentType,
            gv,
            page: currentPage,
            proid,
        };
        const data = await getWeMediaPersonalData(params);

        if (data.code === 200) {
            const totalPage = data.data && data.data.feeds && data.data.feeds.total_page;
            const pagesize = data.data && data.data.feeds && data.data.feeds.limit;

            this.setState(
                {
                    data: {
                        userinfo: data.data.userinfo,
                        list: data.data.feeds.list,
                    },
                    pagesize,
                    totalPage,
                    type: currentType,
                    page: currentPage,
                },
                () => {
                    const { data } = this.state;
                    const { userinfo } = data;
                    const { guid } = userinfo;

                    // 判断是否是第一次进页面
                    if (!newType && !newPage) {
                        /**
                         * 页面统计埋点
                         **/
                        h5PageCount([
                            {
                                datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                                behavior: 'page',
                                type: 'selfpage',
                                other: {
                                    id: `sp_${guid}`,
                                    ref: encodeURIComponent(document.referrer),
                                    url: encodeURIComponent(location.href),
                                },
                            },
                        ]);
                    }

                    this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
                },
            );
        } else {
            console.error(data.msg);
        }
    };

    async componentDidMount() {
        currentDom = this.content.current;
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);

        this.getContentData();
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    /**
     * 滚动条滚动
     */
    handleScroll = async () => {
        const old = this.position;
        let scroll = null;

        scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.position = scroll;

        // 判断滚动条位置
        if (old !== null && this.position !== null && old >= scroll) return;

        const top = currentDom.offsetTop + currentDom.clientHeight;

        let { page } = this.state;
        const gv = CONFIG.gv;

        const { share_token, type, totalPage, data, flag, isLoadEnd } = this.state;

        if (
            scroll + (window.innerHeight || document.documentElement.clientHeight) >= top - 200 &&
            page < totalPage &&
            flag &&
            !isLoadEnd
        ) {
            this.setState({ flag: false });
            page += 1;

            const params = {
                share_token,
                type,
                gv,
                page,
            };

            const newData = await getWeMediaPersonalData(params);
            let newList = [];

            if (newData.code === 200) {
                newList = newData.data && newData.data.feeds && newData.data.feeds.list;
            } else {
                console.error(newData.msg);
            }

            const list = data.list;

            this.setState({
                data: {
                    ...data,
                    list: list.concat(newList),
                },
                page,
                flag: true,
                isLoadEnd: newList.length === 0, // 判断是空就不要分页
            });
        }
    };

    tabSwitch = type => {
        const page = 1;

        // isLoadEnd还原
        this.setState({ isLoadEnd: false });

        this.unHandleSrcoll();
        this.getContentData(type, page);
    };

    mainDom = pageInfo => {
        const { data, type, page, totalPage, flag, isLoadEnd } = this.state;
        const { list } = data;
        let mainDom = <NoOriginal />;

        if (list.length > 0) {
            if (page < totalPage && !isLoadEnd) {
                mainDom = (
                    <div>
                        <Main content={list} type={type} pageInfo={pageInfo} />
                        {flag ? '' : <ToBottomNoData title="加载中" />}
                    </div>
                );
            } else {
                mainDom = (
                    <div>
                        <Main content={list} type={type} pageInfo={pageInfo} />
                        <ToBottomNoData title="已显示全部数据" />
                    </div>
                );
            }
        }

        return mainDom;
    };

    render() {
        const { data, nav } = this.state;
        const { userinfo, list } = data;

        const { guid, nickname, userimg, introduction, fans_num, follow_num } = userinfo;

        const pageInfo = {
            type: personalPageType,
            id: '',
            url: '',
            userId: guid,
            lev: userinfo.lev || '',
            nickname,
            userimg,
        };

        const callupHeadData = {
            isVideoShare,
            hotKeyword: [
                '这条最新发布的内容，80%的网友都在看',
                '热热热！这条精彩内容，你的朋友们都在看',
                '过去24小时发生了这些好玩的事，点击查看',
                '全网最热新闻出炉，这些事儿你都知道吗？',
                '想不到！今天最火爆的新闻居就是……',
                '这条重磅新闻刚刚发布！快来查看',
                '过去的24小时你错过了这些重要新闻……',
                '今天这条消息，90%的人都不知道！',
            ],
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: encodeURIComponent(location.href),
                kind: 'selfpage',
                callupKind: 'default_upopen',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: encodeURIComponent(location.href),
                kind: 'selfpage',
                callupKind: 'default_grgxfc',
            },
            pageInfo,
        };

        const title = nickname ? `${nickname}的个人主页` : '';

        const shareInfo = {
            title,
            img: userimg,
            desc: introduction,
        };

        const newUserinfo = {
            ...userinfo,
            logo: userimg,
            fansNum: fans_num,
            weMediaName: nickname,
            description: introduction,
            unsubNum: follow_num,
        };

        return (
            <React.Fragment>
                <TwiceShare content={shareInfo} />
                <div className={list.length > 0 ? styles.content_bg_gray : styles.content_bg_white} ref={this.content}>
                    <CallupHead content={callupHeadData} />
                    {isNullObject(userinfo) ? <UserInfo content={newUserinfo} /> : null}
                    <div className={styles.space} />
                    {nav.length > 0 ? <SwitchTab content={nav} tabSwitch={this.tabSwitch} /> : null}
                    {this.mainDom(pageInfo)}
                </div>
                {list.length > 0 && <FiXbottom pageInfo={pageInfo} />}
            </React.Fragment>
        );
    }
}

export default errorBoundary(Content);
